import React from 'react'

import i18n from 'live/services/i18n'

import { AlarmCountCardContainer, CardColor, NoInfo } from './styles'

interface IProps {
    alarmCount: number
    alarmStatus: string
    color: string
    loading: boolean
}

export const AlarmCountCard: React.FC<IProps> = ({ alarmCount, alarmStatus, color, loading }) => {
    return (
        <AlarmCountCardContainer color={color}>
            {/* <CardColor color={color} /> */}
            <div className="alarm-card-content">
                {loading ? (
                    <NoInfo>
                        <i className="fa fa-spinner fa-spin" />
                    </NoInfo>
                ) : (
                    <span className="count">{alarmCount}</span>
                )}
                <span className="alarm-status">{alarmStatus}</span>
                <span className="trigger">{i18n('triggered on the last 7 days')}</span>
            </div>
        </AlarmCountCardContainer>
    )
}
